import 'reflect-metadata';
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { configure as mobxConfigure } from 'mobx';
import App from 'App/App';

mobxConfigure({ enforceActions: 'observed' });
ReactDOM.render(<App />, document.getElementById('root'));
